import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')(
  ({ theme }) =>
    `
  display: flex;
  justify-content: center;
  margin-bottom: ${theme.DS_spacing(['xl'])};
`,
);

export const StyledWrapperLoader = styled('div')(
  () =>
    `
    margin-left: 70px;
    padding: 16px;
`,
);
